export type Nacionalidade = 'Brasil' | 'Chile' | 'Internacional'

export type TTelefonePaisConfig = {
  origemLocal: string
  codigoPais: string
  limiteDigitosLocal: number
  placeholderLocal: string
  placeholderInternacional: string
  formatarLocal: (digits: string) => string
  opcoesOrigem: ReadonlyArray<{ value: string; label: string; displayText: string }>
}

export class TelefoneUtils {
  static formatarTelefoneBrasil(digits: string): string {
    if (!digits) return ''
    const limitedDigits = digits.slice(0, 11)
    let formatted = '+55 (' + limitedDigits.slice(0, 2)
    if (limitedDigits.length <= 2) return formatted + ')'
    formatted += ') '
    const rest = limitedDigits.slice(2, 11)
    if (rest.length <= 4) return formatted + rest
    const nine = rest.length === 9
    const first = nine ? rest.slice(0, 5) : rest.slice(0, 4)
    const last = rest.slice(first.length)
    return `${formatted}${first}-${last}`
  }

  static formatarTelefoneChile(digits: string): string {
    if (!digits) return ''
    const limitedDigits = digits.slice(0, 9)
    const formatted = `+56 ${limitedDigits.slice(0, 1)}`
    if (limitedDigits.length <= 1) return formatted
    const rest = limitedDigits.slice(1)
    if (rest.length <= 4) return `${formatted} ${rest}`
    return `${formatted} ${rest.slice(0, 4)}-${rest.slice(4)}`
  }

  static formatarTelefone(numero: string, nacionalidade: Nacionalidade): string {
    if (nacionalidade === 'Brasil') return this.formatarTelefoneBrasil(numero)
    if (nacionalidade === 'Chile') return this.formatarTelefoneChile(numero)
    return numero
  }
}

export const configTelefoneBrasil: TTelefonePaisConfig = {
  origemLocal: 'Brasil',
  codigoPais: '55',
  limiteDigitosLocal: 11,
  placeholderLocal: '(DDD) Telefone',
  placeholderInternacional: 'DDI (DDD) Telefone',
  formatarLocal: (digits) => TelefoneUtils.formatarTelefoneBrasil(digits),
  opcoesOrigem: [
    { value: 'Brasil', label: 'Brasil (+55)', displayText: 'BRA' },
    { value: 'Internacional', label: 'Internacional', displayText: 'INT' },
  ],
}

export const configTelefoneChile: TTelefonePaisConfig = {
  origemLocal: 'Chile',
  codigoPais: '56',
  limiteDigitosLocal: 9,
  placeholderLocal: 'X XXXX-XXXX',
  placeholderInternacional: 'DDI (DDD) Telefone',
  formatarLocal: (digits) => TelefoneUtils.formatarTelefoneChile(digits),
  opcoesOrigem: [
    { value: 'Chile', label: 'Chile (+56)', displayText: 'CL' },
    { value: 'Internacional', label: 'Internacional', displayText: 'INT' },
  ],
}
